import Image from 'next/image';
import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export type EmptyStateProps = {
  title: string;
  description: string;
} & HTMLAttributes<HTMLDivElement>;

export const EmptyState = ({
  title,
  description,
  className,
  ...props
}: EmptyStateProps) => {
  return (
    <div
      className={cn(
        'flex flex-col items-start justify-center gap-4 p-10 md:flex-row md:items-center md:justify-start',
        className
      )}
      {...props}
    >
      <Image
        alt="not found"
        height={90}
        src="/assets/not_found_juice.png"
        width={67}
      />
      <div className="flex flex-col">
        <span className="mb-4 font-bold text-base">{title}</span>
        <p className="text-sm">{description}</p>
      </div>
    </div>
  );
};
